import { mainSplitApi } from "../../mainSplitApi";
import { MyAccountEndpoints } from "../../endpoints/myAccount.endpoint";
import MY_ACCOUNT_TAG_TYPES from "./myAccount.tags";

export interface IMyAccountParentResponseItem {
  id: number;
  full_name: string;
  phone: string | null;
  status: string;
  picture: string | null;
  user_type: number | null;
  email: string;
  parent: number | null;
}

export interface IMyAccountParentResponse {
  status: string;
  data: IMyAccountParentResponseItem;
}

export const MyAccountQueryServices = mainSplitApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getMyAccountParent: query<IMyAccountParentResponseItem, void>({
      query: () => ({
        url: MyAccountEndpoints.MyAccountParent,
        method: "GET"
      }),
      providesTags: [MY_ACCOUNT_TAG_TYPES.MY_ACCOUNT_PARENT],
      transformResponse: (response: IMyAccountParentResponse) => response.data
    })
  })
});

export const { useGetMyAccountParentQuery, useLazyGetMyAccountParentQuery } =
  MyAccountQueryServices;
